<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <!-- Unit -->
        <div class="form-section__group">
            <h4 class="form-section__title">BMI</h4>
            <div v-if="!print" role="radiogroup" aria-label="Select BMI Unit">
                <div v-for="(item, index) in $root.t('step3.units')" :key="index">
                    {{ item }}
                </div>
                <div class="btn-group">
                    <input
                        :id="prefix + 'metric'"
                        type="radio"
                        class="btn-check"
                        :name="prefix + 'unit-metric'"
                        :checked="isMetric"
                        @click="changeUnit(true)"
                    />
                    <label class="btn btn-outline-primary" :for="prefix + 'metric'">{{ $t('step3.metric') }}</label>

                    <input
                        :id="prefix + 'imperial'"
                        type="radio"
                        class="btn-check"
                        :name="prefix + 'unit-imperial'"
                        :checked="isImperial"
                        @click="changeUnit(false)"
                    />
                    <label class="btn btn-outline-primary" :for="prefix + 'imperial'">{{ $t('step3.imperial') }}</label>
                </div>
            </div>
        </div>

        <!--  BMI -->
        <div class="form-section__group">
            <!-- Metric Units -->
            <div v-if="isMetric" id="metric-units" class="col-md-6">
                <div class="form-section__group__field">
                    <ValidationProvider v-slot="v" rules="required|bmi|cms">
                        <label class="form-label" for="AdditionalDetails.Bmi.MetricHeight">
                            <div v-for="(item, index) in $root.t('step3.height')" :key="index" class="required">
                                {{ item }}
                            </div>
                        </label>
                        <div class="input-group">
                            <Input
                                v-model="formData.centimeters"
                                class-name="form-control"
                                place-holder="Centimeters"
                                aria-required="true"
                                @keypress.native="isNumber($event)"
                            />
                            <div class="input-group-append">
                                <label :for="prefix + 'AdditionalDetails.Bmi.MetricHeight'" class="input-group-text">Centimeters</label>
                            </div>
                        </div>
                        <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                    </ValidationProvider>
                </div>

                <div class="form-section__group__field">
                    <ValidationProvider v-slot="v" rules="required|bmi|kgs">
                        <label class="form-label" for="AdditionalDetails.Bmi.MetricWeight">
                            <div v-for="(item, index) in $root.t('step3.weight')" :key="index" class="required">
                                {{ item }}
                            </div>
                        </label>
                        <div class="input-group">
                            <Input
                                v-model="formData.kilograms"
                                class-name="form-control"
                                place-holder="Kilograms"
                                aria-required="true"
                                @keypress.native="isNumber($event)"
                            />
                            <div class="input-group-append">
                                <label :for="prefix + 'AdditionalDetails.Bmi.MetricWeight'" class="input-group-text">Kilograms</label>
                            </div>
                        </div>
                        <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                    </ValidationProvider>
                </div>
            </div>

            <!-- Imperial Units -->
            <div v-if="isImperial" id="imperial-units" class="g-3">
                <!-- Height label -->
                <div class="form-section__group__field">
                    <label class="form-label required" for="Bmi_Height">Height</label>
                    <div class="col-sm-6">
                        <div class="d-flex">
                            <!-- feets -->
                            <ValidationProvider v-slot="v" rules="required|bmi|feets">
                                <div class="d-flex">
                                    <Input
                                        v-model="formData.feets"
                                        class-name="form-control"
                                        place-holder="Feet"
                                        aria-required="true"
                                        @keypress.native="isNumber($event)"
                                    />
                                    <div class="input-group-append">
                                        <label
                                            :for="prefix + 'AdditionalDetails.Bmi.ImperialHeightFeet'"
                                            class="input-group-text required"
                                            >Feet</label>
                                    </div>
                                </div>
                                <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                            </ValidationProvider>

                            <!-- inches -->
                            <ValidationProvider v-slot="v" rules="bmi|inches">
                                <div class="d-flex">
                                    <Input
                                        v-model="formData.inches"
                                        class-name="form-control"
                                        place-holder="Inches"
                                        aria-required="true"
                                        @keypress.native="isNumber($event)"
                                    />
                                    <div class="input-group-append">
                                        <label
                                            :for="prefix + 'AdditionalDetails.Bmi.ImperialHeightInches'"
                                            class="input-group-text"
                                            >Inches</label>
                                    </div>
                                </div>
                                <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <!-- Weight -->
                <div class="form-section__group__field">
                    <label class="form-label required" for="Bmi_Weight">Weight</label>
                    <div class="col-sm-6">
                        <!-- Stones -->
                        <div class="d-flex">
                            <ValidationProvider v-slot="v" rules="required|bmi|stones">
                                <div class="d-flex">
                                    <Input
                                        v-model="formData.stones"
                                        class-name="form-control"
                                        place-holder="Stone"
                                        aria-required="true"
                                        @keypress.native="isNumber($event)"
                                    />
                                    <div class="input-group-append">
                                        <label
                                            class="input-group-text required"
                                            :for="prefix + 'AdditionalDetails.Bmi.ImperialWeightStone'"
                                            >Stone</label>
                                    </div>
                                </div>
                                <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                            </ValidationProvider>
                            <!-- Pounds -->
                            <div class="d-flex">
                                <ValidationProvider v-slot="v" rules="bmi|pounds">
                                    <div class="d-flex">
                                        <Input
                                            v-model="formData.pounds"
                                            class-name="form-control"
                                            place-holder="Pounds"
                                            aria-required="true"
                                            @keypress.native="isNumber($event)"
                                        />
                                        <div class="input-group-append">
                                            <label
                                                class="input-group-text"
                                                :for="prefix + 'AdditionalDetails.Bmi.ImperialWeightPounds'"
                                                >Pounds</label>
                                        </div>
                                    </div>
                                    <span v-if="v.validated && v.invalid" class="input-error" v-html="v.errors[0]" />
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- This should not appear in the ApplyOnline.pdf. Only for testing please. -->
        <!-- <div v-if="print && quoteVerify && quoteVerify.insured && quoteVerify.insured.length">
      <div
        v-if="getBmi()"
        class="form-section__group row g-3"
      >
        <div>BMI: {{ getBmi().bmi }}</div>
        <div>{{ $t('step3.statusRefer') }} {{ getBmi().bmiStatusName }}</div>
      </div>
    </div> -->
    </div>
</template>

<script>
import Input from '../../shared/Input.vue'

export default {
    name: 'BmiForm',
    components: {
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
    },
    props: {
        formData: { type: Object, required: true },
        prefix: { type: String, default: '' },
        print: {
            type: Boolean,
            default: false,
        },
        dob: {
            type: String,
            default: null,
        },
        quoteVerify: {
            type: Object,
            require: true,
            default: null,
        },
        isFamily: {
            type: Boolean,
            require: true,
            default: false,
        },
    },
    data() {
        return {
            unit: {
                metric: 0,
                imperial: 1,
            },

            feets: null,
            inches: null,
            stones: null,
            pounds: null,
            metricUnit: true, // false -> imperial
            keysAllowed: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        }
    },
    computed: {
        isMetric() {
            return this.formData.unit == this.unit.metric
        },

        isImperial() {
            return this.formData.unit == this.unit.imperial
        },
    },
    mounted() {},
    methods: {
        isNumber(evt) {
            const keyPressed = evt.key
            if (!this.keysAllowed.includes(keyPressed)) {
                evt.preventDefault()
                return false
            }
        },
        changeUnit(isMetric) {
            if (isMetric) {
                this.formData.unit = this.unit.metric
                this.formData.kilograms = undefined
                this.formData.centimeters = undefined
                this.formData.feets = 0
                this.formData.inches = 0
                this.formData.stones = 0
                this.formData.pounds = 0
            } else {
                this.formData.unit = this.unit.imperial
                this.formData.kilograms = 0
                this.formData.centimeters = 0
                this.formData.feets = undefined
                this.formData.inches = undefined
                this.formData.stones = undefined
                this.formData.pounds = undefined
            }

            this.metricUnit = isMetric
        },
        changeInsuranceProvider(status) {
            if (status) {
                this.additionalDetails.insuranceProvider = {
                    coverEndDate: null,
                    providerCompanyName: '',
                }
            } else {
                this.form.insuranceProvider = null
            }
        },
        getBmi() {
            let insured = this.quoteVerify.insured.find(
                (i) => new Date(i.dateOfBirth).getTime() == new Date(this.dob).getTime(),
            )
            return (insured && insured.bmi) || null
        },
    },
}
</script>
